// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 872) return "static/chunks/e01b8c46-f9fc24ecbc53f526.js";
	if (chunkId === 960) return "static/chunks/960-d65f9c56b7bcfe6c.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 359 ? "f4052ef2" : chunkId) + "." + {"56":"90aec1f752240041","359":"ded6522a6aa14030","907":"bd622208057f996a"}[chunkId] + ".js";
};